import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Box, Paper, Typography } from "@mui/material";
import { styled } from "@mui/system";

// Register Chart.js components
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const FeedbackBarGraph = ({ feedbackData }) => {
  // Example feedbackData: { good: 10, veryGood: 15, poor: 5 }

  const data = {
    labels: ["Good", "Very Good", "Poor"],
    datasets: [
      {
        label: "Feedback Responses",
        data: [feedbackData.good, feedbackData.veryGood, feedbackData.poor],
        backgroundColor: ["#000", "#2196f3", "#f44336"],
        borderColor: ["#388e3c", "#1976d2", "#d32f2f"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <StyledPaper>
      <Typography variant="h6">Feedback Responses</Typography>
      <Bar data={data} options={options} />
    </StyledPaper>
  );
};

export default FeedbackBarGraph;
